import { Grid } from '@mui/material';
import { styles } from '../../../forms/BusinessRelations/styles';
import { TableActionButtons } from '~/components/ListCardTable/TableActionButtons';
import TableCell from '~/components/ListCardTable/TableCell';
import { FormInput } from '~/components/FormComponents/FormInput';
import { FormDateInput } from '~/components/FormComponents/FormDateInput';
import { VirtualItem } from '@tanstack/react-virtual';
import { LICENSE_ROW_HEIGHT } from '~/modules/identification/constants';

interface ILicenseTableRowProps {
  showRemove: boolean;
  append: () => void;
  remove: () => void;
  virtualItem: VirtualItem;
  isLastItem?: boolean;
}

const LicenseTableRow = ({
  showRemove,
  append,
  remove,
  virtualItem,
  isLastItem = false,
}: ILicenseTableRowProps) => {
  const { index } = virtualItem;
  return (
    <Grid
      container
      sx={[
        styles.licenseRow,
        { zIndex: 0, borderBottom: isLastItem ? 'none' : '', height: LICENSE_ROW_HEIGHT },
      ]}
    >
      <TableCell title="Найменування ліцензії" size={3}>
        <FormInput
          name={`licenses.${index}.licenseName`}
          placeholder="Введіть найменування ліцензії"
          variant="standard"
          fullWidth
          sx={{ ...styles.tableInput, pt: '14px' }}
          inputProps={{ minLength: 1, maxLength: 255 }}
        />
      </TableCell>
      <TableCell title="Дата видачі" size={2}>
        <FormDateInput
          name={`licenses.${index}.licenseDate`}
          variant="standard"
          placeholder="Введіть дату видачі"
          sx={{ mt: '14px', '& .MuiInputBase-input': { pl: 2 } }}
        />
      </TableCell>
      <TableCell title="Номер ліцензії" size={2}>
        <FormInput
          name={`licenses.${index}.licenseNumber`}
          placeholder="Номер ліцензії"
          variant="standard"
          fullWidth
          sx={{ ...styles.tableInput, pt: '14px' }}
          inputProps={{ minLength: 1, maxLength: 255 }}
        />
      </TableCell>
      <TableCell title="Ким видана ліцензія" size={2}>
        <FormInput
          name={`licenses.${index}.licenseOrganisationCreate`}
          placeholder="Ким видана ліцензія"
          variant="standard"
          fullWidth
          sx={{ ...styles.tableInput, pt: '14px' }}
          inputProps={{ minLength: 1, maxLength: 255 }}
        />
      </TableCell>
      <TableCell title="Термін дії ліцензії" size={2}>
        <FormDateInput
          name={`licenses.${index}.licenseExpiryTerm`}
          variant="standard"
          placeholder="Введіть термін дії ліцензії"
          sx={{ mt: '14px', '& .MuiInputBase-input': { pl: 2 } }}
        />
      </TableCell>
      <TableActionButtons addClick={append} removeClick={remove} showRemove={showRemove} />
    </Grid>
  );
};

export default LicenseTableRow;
